import React from "react";

const Warranty = () => {
  return (
    <div className="terms-container">
      <h1>Return & Warranty Policy</h1>

      <p>
        Transcare Agencies provides warranty coverage for our clean
        cookstoves against manufacturing defects.
      </p>

      <h3>Warranty Coverage</h3>
      <p>
        Our warranty covers defects in materials or workmanship under
        normal use.
      </p>

      <h3>Warranty Exclusions</h3>
      <p>
        The warranty does not cover damage caused by misuse, improper
        handling, or unauthorized repairs.
      </p>

      <h3>Returns</h3>
      <p>
        If a product has a manufacturing defect, customers may contact
        Transcare Agencies for repair or replacement.
      </p>

      <h3>Contact for Support</h3>
      <p>
        For warranty claims, please contact us through the contact details
        available on our website.
      </p>
    </div>
  );
};

export default Warranty;